import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Constants } from 'src/app/common/constants';
import { SeoService } from 'src/app/common/seo.service';
import * as AOS from 'aos';
@Component({
  selector: 'app-our-project-approach',
  templateUrl: './our-project-approach.component.html',
  styleUrl: './our-project-approach.component.css'
})
export class OurProjectApproachComponent {
  baseUrl = Constants.baseUrl;
    isBrowser:boolean=false;
    constructor( private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private seoService:SeoService,
    private metaService: Meta) {this.isBrowser=isPlatformBrowser(this.platformId);}
    ngOnInit(): void {
      this.seoService.createLinkForCanonicalURL();
      this.setTitleAndMetaTags();
      let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mitresource.com/projectApproach/"
    },
    "headline": "Efficient Agile Project Management Services | Maganti IT",
    "description": "Maganti IT offers efficient Agile project management services to deliver software solutions faster with better collaboration, flexibility, and transparency.",
    "image": "https://mitresource.com/assets/images/techstaffing-images/applicationmodernization.png",  
    "author": {
      "@type": "Organization",
      "name": "Maganti IT",
      "url": "https://mitresource.com/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Maganti IT",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
      }
    },
    "datePublished": "2024-10-28"
  }
  `;
    this._renderer2.appendChild(this._document.body, script);
      if(this.isBrowser){     
        AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
        AOS.init({
          once: true, 
        });
      }
      this.setTitleAndMetaTags();
      this.seoService.createLinkForCanonicalURL();
    }
    private setTitleAndMetaTags(): void {
      this.titleService.setTitle('Efficient Agile Project Management Services | Maganti IT');
      this.metaService.addTags([
        { name: 'description', content: 'Maganti IT offers efficient Agile project management services to deliver software solutions faster with better collaboration, flexibility, and transparency.' },
        { property: 'og:type', content: 'website' },
        { property: 'link:icon', content: '/assets/images/banners/mit-favicon.png' },
        { property: 'og:title', content: 'Efficient Agile Project Management Services | Maganti IT' },
        { property: 'og:url', content: 'https://mitresource.com/projectApproach/' },
        { property: 'og:image', content: 'https://mitresource.com/assets/images/ProjectApproach-images/person-working-html-computer 2.jpg' },
        { property: 'og:description', content: "Accelerate your digital transformation with Maganti IT's Agile project management services. Timely delivery, adaptable processes, and team alignment guaranteed." },
      ]);
    }
    
  cards = [
    {
      image: '../../../assets/images/ProjectApproach-images/dashboarddetails.png',
      title: 'How we keep you in the loop',
      points: [
        { label: 'Weekly Status Calls', text: 'progress, blockers, priorities' },
        { label: 'Sprint Reviews', text: 'Demo features, gather feedback' },
        { label: 'Executive Check-ins', text: 'Monthly strategic review' },
      ]
    },
    
  ];
  
}
